import { jsx as t, jsxs as B } from "react/jsx-runtime";
import { z as o } from "zod";
import { withManagedProps as W } from "@made-people/managed-props";
import { withZod as j } from "@made-people/react-prop-guard";
import Io from "clsx";
import { useState as i, useCallback as k, useMemo as ko } from "react";
import { Drawer as H } from "@made-people/blueprint-drawer";
import { MagnifierIcon as Ho, CrossIcon as jo } from "@made-people/blueprint-icons";
import { LinkShortcuts as Co } from "@made-people/blueprint-link-shortcuts";
import { buttonAsLinkSchema as _o } from "@made-people/blueprint-button";
import { componentWrapperLayoutSchema as d, ComponentWrapper as wo } from "@made-people/blueprint-component-wrapper";
import { headingSchema as h } from "@made-people/blueprint-heading";
import { useOverlayState as Lo, overlayEventEmitter as go } from "@made-people/blueprint-overlay";
import { searchInputSchema as Eo, SearchInput as xo, PhraseSuggestionList as Po, LinkSuggestionsList as Ro, RecentSearchesList as Ao, ProductList as To, CategorySuggestionsList as No } from "@made-people/blueprint-search";
import { useNavigate as Do, useHref as Mo } from "@made-people/grease-link";
import { useAutoCompleteSearch as Oo } from "@made-people/grease-search";
import { useTranslate as So } from "@made-people/grease-translations";
import { searchSidebarSuggestionsStyling as zo } from "./index-blueprint.es.js";
import { useBreakpoint as Bo } from "@made-people/ui-hooks";
import "@made-people/blueprint";
const Fo = Eo.merge(
  o.object({
    layout: d.optional()
  })
), q = o.object({
  drawerSettings: o.custom().optional().describe("Settings for the drawer"),
  variants: o.custom().optional(),
  direction: o.object({
    desktop: o.enum(["right", "left", "bottom"]).optional(),
    mobile: o.enum(["right", "left", "bottom"]).optional()
  }).optional(),
  icons: o.object({
    searchIcon: o.custom().or(o.literal(!1)).optional(),
    closeIcon: o.custom().or(o.literal(!1)).optional()
  }).optional(),
  // Type errors if using productListSchema: Length is too long
  productListSettings: o.any().optional(),
  isDesktop: o.boolean().optional(),
  autoCompletePhrasesSettings: o.object({
    heading: h.optional(),
    layout: d.optional()
  }).optional().describe("Settings for the autocomplete phrases section"),
  recentSearchesSettings: o.object({
    isEnabled: o.boolean().optional(),
    heading: h.optional(),
    layout: d.optional()
  }).optional().describe("Settings for the recent searches section"),
  autoCompleteProductsSettings: o.object({
    layout: d.optional(),
    heading: h.optional().describe("Heading for the autocomplete products section")
  }).optional().describe("Settings for the autocomplete products section"),
  suggestedCategories: _o.array().optional().describe("Settings for the suggested categories section"),
  emptyStateSlot: o.custom().optional().describe("Settings for the empty state slot"),
  searchInputSettings: Fo.optional().describe("Settings for the search input component"),
  linkShortcutsSettings: o.object({
    layout: d.optional()
  }).optional().describe("Settings for the link shortcuts component"),
  linkSuggestionsSettings: o.object({
    isEnabled: o.boolean().optional(),
    heading: h.optional(),
    layout: d.optional()
  }).optional().describe("Settings for the link suggestions section"),
  categorySuggestionsSettings: o.object({
    isEnabled: o.boolean().optional(),
    heading: h.optional(),
    layout: d.optional()
  }).optional().describe("Settings for the category suggestions section")
}), Wo = W(
  "SearchSuggestions",
  j(
    {
      schema: q,
      defaultProps: {
        recentSearchesSettings: {
          isEnabled: !1
        },
        linkSuggestionsSettings: {
          isEnabled: !1
        },
        categorySuggestionsSettings: {
          isEnabled: !1
        },
        icons: {
          searchIcon: /* @__PURE__ */ t(Ho, {}),
          closeIcon: /* @__PURE__ */ t(jo, {})
        }
      }
    },
    ({
      icons: e,
      isDesktop: m,
      autoCompletePhrasesSettings: r,
      autoCompleteProductsSettings: u,
      suggestedCategories: p,
      emptyStateSlot: G,
      searchInputSettings: J,
      linkShortcutsSettings: f,
      linkSuggestionsSettings: n,
      categorySuggestionsSettings: c,
      recentSearchesSettings: l
    }) => {
      var M, O, S, z;
      const [K, Q] = i(""), [b, C] = i(""), [_, U] = i([]), { execute: w } = Oo(), s = So(), y = zo.styles(), [L, V] = i([]), g = L.length > 0, X = _.length > 0, [E, Y] = i(
        []
      ), $ = E.length > 0, [x, oo] = i([]), eo = x.length > 0, [P, ao] = i([]), to = P.length > 0, R = Do(), A = Mo(), ro = Lo("search-sidebar"), no = k(
        async (a) => {
          try {
            const {
              productSuggestions: I,
              phraseSuggestions: bo,
              recentSearches: fo,
              linkSuggestions: yo,
              categorySuggestions: vo
            } = await w({
              searchQuery: a,
              limit: 5
            });
            Y(bo ?? []), V(I), U(fo ?? []), oo(yo ?? []), ao(vo ?? []), C(a);
          } catch (I) {
            console.error(I);
          }
        },
        [w]
      ), co = async (a) => {
        no(a);
      }, lo = k(
        (a) => co(a),
        []
        // or [] if handleSearchResults is stable
      ), so = ko(
        () => ({ search: e == null ? void 0 : e.searchIcon }),
        [e == null ? void 0 : e.searchIcon]
      ), v = k(() => {
        Q(""), C(""), go.emit("close", { overlayId: "search-sidebar" });
      }, []), io = (a) => {
        R(A(a)), v();
      }, T = (a) => a && io("search?q=" + a), N = (a) => {
        R(A(a)), v();
      }, D = (p == null ? void 0 : p.map((a) => ({
        label: a.label,
        context: "search-sidebar",
        link: a == null ? void 0 : a.link
      }))) || [], po = D.length > 0, { layout: ho, autoFocus: mo, ...uo } = J ?? {};
      return /* @__PURE__ */ B("div", { className: y.base, children: [
        /* @__PURE__ */ B(
          wo,
          {
            className: y.searchInputContainer,
            layout: ho,
            children: [
              /* @__PURE__ */ t(
                xo,
                {
                  ...uo,
                  autoFocus: m ? mo : !1,
                  icons: so,
                  autoComplete: { enabled: !1 },
                  placeholder: {
                    enabled: !0,
                    text: s("Search_Suggestions_Placeholder")
                  },
                  clear: { enabled: !0, text: s("Clear_Search_Input") },
                  searchResultsCallback: lo,
                  feedbackQuery: K,
                  onSubmitCallback: v
                },
                ro.isOpen ? "open" : "closed"
              ),
              (e == null ? void 0 : e.closeIcon) && /* @__PURE__ */ t(
                H.Close,
                {
                  className: Io(y.closeButton, !m && "hidden"),
                  children: e.closeIcon
                }
              )
            ]
          }
        ),
        $ && b && /* @__PURE__ */ t(
          Po,
          {
            phrases: E,
            settings: {
              heading: {
                heading: s("Search_Suggestions_Heading"),
                variants: (M = r == null ? void 0 : r.heading) == null ? void 0 : M.variants
              },
              layout: r == null ? void 0 : r.layout
            },
            clickHandler: T
          }
        ),
        (n == null ? void 0 : n.isEnabled) && eo && /* @__PURE__ */ t(
          Ro,
          {
            linkSuggestions: x,
            settings: {
              heading: {
                heading: s("Link_Suggestions_Heading"),
                variants: (O = n == null ? void 0 : n.heading) == null ? void 0 : O.variants
              },
              layout: n == null ? void 0 : n.layout
            },
            clickHandler: N
          }
        ),
        (l == null ? void 0 : l.isEnabled) && X && !b && /* @__PURE__ */ t(
          Ao,
          {
            phrases: _,
            settings: {
              heading: {
                heading: s("Recent_Searches_Heading"),
                variants: (S = l == null ? void 0 : l.heading) == null ? void 0 : S.variants
              },
              layout: l == null ? void 0 : l.layout
            },
            clickHandler: T
          }
        ),
        g && /* @__PURE__ */ t(
          To,
          {
            products: L,
            settings: u
          }
        ),
        (c == null ? void 0 : c.isEnabled) && to && /* @__PURE__ */ t(
          No,
          {
            categorySuggestions: P,
            settings: {
              heading: {
                heading: s("Category_Suggestions_Heading"),
                variants: (z = c == null ? void 0 : c.heading) == null ? void 0 : z.variants
              },
              layout: c == null ? void 0 : c.layout
            },
            clickHandler: N
          }
        ),
        !b && po && /* @__PURE__ */ t(
          Co,
          {
            content: {
              heading: {
                heading: s("Suggested_Categories_Heading"),
                variants: { headingSize: "md" }
              },
              links: D
            },
            layout: f == null ? void 0 : f.layout
          }
        ),
        !g && !b && G
      ] });
    }
  )
), Z = o.object({ template: o.literal("search-suggestions") }).and(q), qo = j(Z, (e) => {
  switch (e.template) {
    case "search-suggestions":
      return /* @__PURE__ */ t(Wo, { ...e });
    default:
      return null;
  }
}), F = "search-suggestions", Zo = o.object({
  settings: Z.optional()
}), pe = W(
  "SearchSidebar",
  j(
    {
      schema: Zo,
      defaultProps: {
        settings: {
          template: F,
          direction: {
            desktop: "right",
            mobile: "bottom"
          },
          drawerSettings: {
            variants: {
              rounded: {
                initial: "medium",
                lg: "none"
              },
              minHeight: "half-viewport",
              dimmed: "subtle",
              blurred: "none",
              background: "white"
            },
            hasHandle: !0
          }
        }
      }
    },
    ({ settings: e }) => {
      var u, p;
      const m = e || {
        template: F
      }, r = Bo().desktop;
      return /* @__PURE__ */ t(
        H,
        {
          customOverlayId: "search-sidebar",
          type: "drawer",
          direction: r && ((u = e == null ? void 0 : e.direction) != null && u.desktop) ? e.direction.desktop : !r && ((p = e == null ? void 0 : e.direction) != null && p.mobile) ? e.direction.mobile : "bottom",
          "data-id": "search-sidebar",
          ...e == null ? void 0 : e.drawerSettings,
          children: /* @__PURE__ */ t(H.Content, { children: /* @__PURE__ */ t(qo, { isDesktop: r, ...m }) })
        }
      );
    }
  )
);
export {
  pe as SearchSidebar,
  Wo as SearchSuggestions,
  qo as TemplateSelector,
  Zo as searchSidebarPropsSchema,
  q as searchSidebarSchema,
  Z as templateSelectorSchema
};
//# sourceMappingURL=index.es.js.map
